import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-964bc66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "supervision-editor" }
const _hoisted_2 = { class: "help-text" }
const _hoisted_3 = { class: "list-unstyled user-list" }
const _hoisted_4 = { class: "item-actions" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Child accounts you manage ", -1))
const _hoisted_7 = { class: "list-unstyled user-list" }
const _hoisted_8 = { class: "item-actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "list-actions" }

import { computed, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useUserSupervisorStore } from '@/gp/UserSupervisorStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { useTokenManager } from '@/auth/TokenManager'
import { NewProfileRelationship } from '@/manage/profiles/ProfileManager'
import UserItem from './UserItem.vue'
import UserAddModal from './UserAddModal.vue'
import ProfileAddRelatedModal from '@/manage/profiles/ProfileAddRelatedModal.vue'
import UserSupervisorRemoveModal from './UserSupervisorRemoveModal.vue'
import UserSupervisorAddModal from './UserSupervisorAddModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSupervisionEditor',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;



const profileAddRelatedModalRef = ref<InstanceType<typeof ProfileAddRelatedModal>>()
const userAddModalRef = ref<InstanceType<typeof UserAddModal>>()
const userSupervisorAddModalRef = ref<InstanceType<typeof UserSupervisorAddModal>>()
const userSupervisorRemoveModalRef = ref<InstanceType<typeof UserSupervisorRemoveModal>>()

const userStore = useUserStore()
const userSupervisorStore = useUserSupervisorStore()
const dataGroupStore = useDataGroupStore()
const tokenManager = useTokenManager()

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId!)
const isSelfRef = computed(() => userIdRef.value == tokenManager.current.userId)
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const userProfileGroupRef = computed(() => dataGroupStore.getAsyncGroup(userRef.value?.profileDataGroupId, LoadMode.EnsureLoaded)?.data)
const permissionsRef = computed(() => userStore.getAsyncPermissions(userIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const isUserAdminRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) > 0)
const isSupervisorRef = computed(() => !isSelfRef.value && isUserAdminRef.value)
const supervisedUsersRef = computed(() => !isUserAdminRef.value ? [] :
  userSupervisorStore.getForSupervisor(userIdRef.value, LoadMode.EnsureLoaded))
const supervisorsRef = computed(() => !(isUserAdminRef.value || isSelfRef.value) ? [] :
  userSupervisorStore.getForSupervisedUser(userIdRef.value, LoadMode.EnsureLoaded))
const showAddSupervisedRef = computed(() => isSelfRef.value && isUserAdminRef.value)
const showAddFirstSupervisorRef = computed(() => isSelfRef.value && isUserAdminRef.value && supervisedUsersRef.value.length == 0)

function onRemove(userSupervisedId: string) {
  userSupervisorRemoveModalRef.value?.open(userSupervisedId)
}

function addSupervisedUser() {
  if (userProfileGroupRef.value) {
    profileAddRelatedModalRef.value?.open(
      NewProfileRelationship.Son,
      userProfileGroupRef.value.startItemId!)
  }
}

function addSupervisor() {
  userSupervisorAddModalRef.value?.open(userIdRef.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isSelfRef.value && supervisorsRef.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Parent accounts help parents protect your personal information and decide which features are enabled for you on the site. ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Parent accounts can manage one or more child accounts to help protect the child’s personal information and decide which features are enabled for them on the site. ")
          ], 64))
    ]),
    (supervisorsRef.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h5", null, [
            (isSelfRef.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" Parents who manage your account ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Parents who manage this account ")
                ], 64))
          ]),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supervisorsRef.value, (sup) => {
              return (_openBlock(), _createElementBlock("li", {
                key: sup.id
              }, [
                _createVNode(UserItem, {
                  "user-id": sup.supervisorId
                }, null, 8, ["user-id"]),
                _createElementVNode("div", _hoisted_4, [
                  (isUserAdminRef.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-inline btn-link",
                        onClick: ($event: any) => (onRemove(sup.id!))
                      }, " Remove ", 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (supervisedUsersRef.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supervisedUsersRef.value, (sup) => {
              return (_openBlock(), _createElementBlock("li", {
                key: sup.id
              }, [
                _createVNode(UserItem, {
                  "user-id": sup.forUserId
                }, null, 8, ["user-id"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-inline btn-link",
                    onClick: ($event: any) => (onRemove(sup.id!))
                  }, " Remove ", 8, _hoisted_9)
                ])
              ]))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (showAddSupervisedRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: addSupervisedUser
          }, " Add a child account "))
        : _createCommentVNode("", true),
      (showAddFirstSupervisorRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: addSupervisor
          }, " Make this a child account "))
        : _createCommentVNode("", true),
      (isSupervisorRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "btn btn-inline btn-link",
            onClick: addSupervisor
          }, " Add another parent account "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ProfileAddRelatedModal, {
      ref_key: "profileAddRelatedModalRef",
      ref: profileAddRelatedModalRef
    }, null, 512),
    _createVNode(UserAddModal, {
      ref_key: "userAddModalRef",
      ref: userAddModalRef
    }, null, 512),
    _createVNode(UserSupervisorAddModal, {
      ref_key: "userSupervisorAddModalRef",
      ref: userSupervisorAddModalRef
    }, null, 512),
    _createVNode(UserSupervisorRemoveModal, {
      ref_key: "userSupervisorRemoveModalRef",
      ref: userSupervisorRemoveModalRef
    }, null, 512)
  ]))
}
}

})